import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'
import { type ButtonVariant } from '../../../components/Button/Button'

interface ConfirmDialogProps {
  title: string
  body: string
  confirmLabel?: string
  confirmVariant?: ButtonVariant
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  title,
  body,
  confirmLabel = 'Confirm',
  confirmVariant = 'danger',
  isLoading = false,
  onConfirm,
  onCancel,
}) => (
  <Modal
    show
    footerClassName='p-4 pt-0'
    onHide={onCancel}
    header={<h5 className='mb-0'>{title}</h5>}
    headerBodySeparator
    body={<div className='paragraph-medium'>{body}</div>}
    showFooterActions
    footerPrimaryActionTitle={confirmLabel}
    footerPrimaryActionButtonVariant={confirmVariant}
    footerPrimaryActionLoading={isLoading}
    footerSecondaryActionTitle='Cancel'
    onFooterPrimaryAction={onConfirm}
    onFooterSecondaryAction={onCancel}
  />
)
